// V2 Dashboard Action Types
export const OPEN_V2_DASHBOARD = 'OPEN_V2_DASHBOARD';
export const CLOSE_V2_DASHBOARD = 'CLOSE_V2_DASHBOARD';
